import CONQUER from "../../CONQUER";
import LOG, { log } from "../../../UTIL/LOG";
import { ACTIONS } from "../../../Models/ENUM";
import PostInstance from "./PostInstance";

class Awesome
{
    private conquer         : CONQUER;
    private postInstance    : any;

    public value            : number = 0;
 
    public constructor( instance:CONQUER, postInstance:PostInstance ) 
    {
        this.conquer        = instance;
        this.postInstance   = postInstance;
    }

    /*=============== 
 
    GET  
    {
         
    }

    ================*/

    public async get() : Promise<any>
    {
        let entry : any = await this.conquer.do( ACTIONS.JUDGEMENT_GETONE, { postID:this.postInstance.postID } );
        if( entry ) this.value = entry.value;

        return Promise.resolve();
    };

    /*=============== 
 
    SET  
    {
        awesome : -1, 0, 1
    }

    ================*/

    private async set( value:number ) : Promise<any>
    {
        await this.conquer.do( ACTIONS.JUDGEMENT_SET, { postID:this.postInstance.postID, value:value } );
        await this.postInstance.refresh();

        this.value = value;

        return Promise.resolve();
    };

    public async positive() : Promise<any>
    {
        if( this.value == 1 ) return Promise.resolve();

        return this.set( 1 );
    }

    public async negative() : Promise<any>
    {
        if( this.value == -1 ) Promise.resolve();

        return this.set( -1 );
    }

    public async remove() : Promise<any>
    {
        return this.set( 0 );
    }
}

export default Awesome;